(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chatgpt-v61-collection-style"] && !Shopify.designMode) return;
  try {
    /* CHATGPT VERSION 6.4 — START: measure the existing header without changing its layout */
  (() => {
    let cleanup = () => {};
    function initialize() {
      cleanup();
      const shell = document.getElementById('cg61-header-shell');
      const hero = document.querySelector('[data-cg61-hero]');
      if (!shell || !hero) return;
      shell.classList.toggle('cg61-over-image', hero.classList.contains('cg61-hero--image'));
      /* CHATGPT VERSION 7.1 — START: let embedded description colors follow the desktop caption */
      if (hero.classList.contains('cg61-hero--image')) {
        hero.querySelectorAll('.cg61-hero__description [style]').forEach(element => {
          const color = element.style.getPropertyValue('color');
          if (color && !color.includes('--cg71-caption-ink')) {
            const priority = element.style.getPropertyPriority('color');
            element.style.setProperty('color', 'var(--cg71-caption-ink, ' + color + ')', priority);
          }
        });
      }
      /* CHATGPT VERSION 7.1 — END: retain each embedded color as the phone fallback */
      let frame = 0;
      let active = true;
      function measure() {
        frame = 0;
        const height = shell.getBoundingClientRect().height + 'px';
        if (document.body.style.getPropertyValue('--cg61-header-height') !== height) {
          document.body.style.setProperty('--cg61-header-height', height);
        }
      }
      function schedule() { if (active && !frame) frame = requestAnimationFrame(measure); }
      const observer = new ResizeObserver(schedule);
      observer.observe(shell);
      window.addEventListener('resize', schedule, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
      measure();
      cleanup = () => {
        active = false;
        cancelAnimationFrame(frame);
        observer.disconnect();
        window.removeEventListener('resize', schedule);
      };
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:unload', initialize);
  })();
  /* CHATGPT VERSION 6.4 — END: measure the existing header without changing its layout */
  } catch(e) { console.error(e); }
})();

})();
